<template>
  <UiModal
    :show="showNotic"
    :title="title"
    iconType="apply_2"
    @close="close"
  >
    <div class="inner-content">
      <div class="scroll-box" v-html="lg(config, 'registration_notic', '')"></div>
    </div>
    <div class="agree-box">
      <div class="bg"></div>
      <button class="btn" :disabled="count > 0" @click="handleAgree">
        <UiButton colorType="gold">
          <template v-if="!loading">
            <div v-if="count > 0" class="label-box">
              <span class="label-shadow">{{ btnAgreeWithCount }}</span>
              <span class="label-text">{{ btnAgreeWithCount }}</span>
            </div>
            <div v-else class="label-box">
              <span class="label-shadow">{{ btnAgree }}</span>
              <span class="label-text">{{ btnAgree }}</span>
            </div>
          </template>
          <template v-else>
            <div class="label-box">
              <span class="label-shadow">...</span>
              <span class="label-text">...</span>
            </div>
          </template>
        </UiButton>
      </button>
    </div>
  </UiModal>
</template>

<script setup>
import lg from '@/utils/lg'
import { ref, computed, inject } from 'vue'
import UiModal from "@/components/ui-modal.vue";
import { useAppStore } from '@/store'
import { useConfig } from '@/composables/useConfig'
import { useModal } from '@/composables/useModal'
import * as api from '@/service/index'
import UiButton from '@/components/ui-button';

const handleStep = inject('handleStep')
const updateInfo = inject('updateInfo')

const props = defineProps({
  agree: {
    type: Number,
    default: () => 0
  }
})

const appStore = useAppStore()

const showNotic = ref(false)

const title = ref('报名须知')
const btnAgree = ref('我已阅读并同意')
const btnAgreeWithCount = computed(() => `${btnAgree.value}(${count.value}S)`)
const count = ref(10)
const loading = ref(false)

// 原选项式中挂在实例上的 this.timer
let timer = null

const token = computed(() => appStore.token)
const config = useConfig()

const { close } = useModal('apply-notice', showNotic, {
  onOpen() {
    if (!props.agree) {
      timer && clearInterval(timer)
      count.value = 10
      timer = setInterval(() => {
        count.value -= 1
        if (count.value <= 0) clearInterval(timer)
      }, 1000)
    } else {
      count.value = 0
    }
  },
  onClose() {
    timer && clearInterval(timer)
  }
})

function handleAgree() {
  if(!props.agree && token.value) {
    loading.value = true;
    // 报名入口关闭后这里的新用户还能报名
    api.agreeNotice(token.value).then(r => {
      if(r.status === 200 && r.data.success) {
        // 同意后直接跳第二页
        handleStep(2);
        updateInfo('agree', 1)
      }
      loading.value = false;
      close();
    })
  }else {
    close();
  }
}
</script>

<style lang="scss" scoped>
.inner-content {
  flex: 1;
  width: 956px;
  margin: 30px 0 0 18px;
  padding: 0 52px;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: scroll;

  .scroll-box {
    width: 100%;
    white-space: pre-line;
    font-size: 20px;
    font-weight: 500;
    color: #666;
    :deep(p) {
      margin-top: 0;
      margin-bottom: 15px;
      display: flex;
      img {
        // 后端 v-html 里的 <img> 用 content: url() 顶替为新版图标
        // flex: 0 防止图片未加载完成时被 flex 容器压缩到 ~10px, 加载完成跳变
        content: map-get($icon_singles, 'rule_bullet');
        flex: 0;
        width: 27px;
        height: 27px;
        padding-top: 0;
        margin-right: 14px;
      }
    }
    :deep(h3) {
      font-weight: normal;
      margin: 30px 0 15px;
    }
  }
}
.agree-box {
  position: relative;
  width: 100%;
  height: 142px;
  display: flex;
  justify-content: center;
  .bg {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 156px;
    background: $bg_popup_bottom center/contain no-repeat;
  }
  .btn {
    position: relative;
    height: 71px;
    width: 266px;
    margin-top: 36px;
    font-size: 27px;
    font-weight: bold;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    &:active {
      opacity: 0.8;
    }

    :deep(.ui-button .inner-box) {
      padding: 0 28px;
    }
  }
}
</style>
